// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuetify from "vuetify";
import axios from "axios";
import API_URL from "@/constants/API_URL";
import "vuetify/dist/vuetify.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import VueGeolocation from "vue-browser-geolocation";
import "@mdi/font/css/materialdesignicons.css";
import clampy from "@clampy-js/vue-clampy";

import tinymce from "vue-tinymce-editor";
import App from "./App";
import router from "./router";
import store from "./store";

import "./filters/formatDate";
import BootstrapVue from "bootstrap-vue";

Vue.use(BootstrapVue);
Vue.component("tinymce", tinymce);
Vue.use(clampy);
Vue.use(VueGeolocation);
Vue.use(Vuetify, {
  theme: {
    primary: "#666666",
    secondary: "#FAFAFA",
    accent: "#308afb",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#ffd200",
    docgo: "#4185f4"
  },
  options: {
    themeVariations: ["primary", "secondary", "accent"]
  },
  iconfont: "mdi"
});

Vue.config.productionTip = false;

axios.defaults.baseURL = API_URL();
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      localStorage.clear();
      router.push({ name: "FormSignin" });
    }
    return Promise.reject(error);
  }
);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js